"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var FooterMaker_1 = __importDefault(require("../../FooterMaker"));
var HeaderMaker_1 = __importDefault(require("../../HeaderMaker"));
var RowMaker_1 = __importDefault(require("../../RowMaker"));
var tableConf_1 = require("./tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.transactionsTableConf);
var Footer = (0, FooterMaker_1.default)(tableConf_1.transactionsTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.transactionsTableConf);
var TransactionsTable = function (_a) {
    var transactions = _a.transactions;
    var sortedTransactions = (0, hooks_1.useSortArray)(transactions, tableConf_1.transactionsTableConf.extractors);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedTransactions)) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: transactions.map(function (transaction) { return (0, jsx_runtime_1.jsx)(Row, { item: transaction }, transaction.id); }) }), (0, jsx_runtime_1.jsx)(Footer, { items: sortedTransactions })] }));
};
exports.default = (0, SortHoC_1.default)(TransactionsTable, { key: 'date', order: 1 });
